export const POLICY_STUDIO_BASE = '/content-tools/policy-studio'

export type PolicyStudioMode = 'review' | 'debug'

export const debugPolicyStudioRoutes = {
  mode: 'debug' as const,
  home: () => `${POLICY_STUDIO_BASE}/debug`,
  document: (docId: string) =>
    `${POLICY_STUDIO_BASE}/debug/${encodeURIComponent(docId)}`,
  jobs: () => `${POLICY_STUDIO_BASE}/debug/jobs`,
  submit: () => `${POLICY_STUDIO_BASE}/debug/submit`,
}

export const reviewPolicyStudioRoutes = {
  mode: 'review' as const,
  home: () => POLICY_STUDIO_BASE,
  source: (sourceId: string) =>
    `${POLICY_STUDIO_BASE}/sources/${encodeURIComponent(sourceId)}`,
  add: () => `${POLICY_STUDIO_BASE}/add`,
}

export type DebugPolicyStudioRoutes = typeof debugPolicyStudioRoutes
export type ReviewPolicyStudioRoutes = typeof reviewPolicyStudioRoutes

export interface PolicyStudioCrossAddress {
  docId: string
  sourceId?: string
}

// Today source and document ids are 1:1. Keep the translation here so source
// versioning can diverge without teaching shared callers about route shape.
export const crossTo = (
  mode: PolicyStudioMode,
  { docId, sourceId }: PolicyStudioCrossAddress,
) =>
  mode === 'debug'
    ? debugPolicyStudioRoutes.document(docId)
    : reviewPolicyStudioRoutes.source(sourceId ?? docId)

export function policyStudioRoutes(mode: 'debug'): DebugPolicyStudioRoutes
export function policyStudioRoutes(mode: 'review'): ReviewPolicyStudioRoutes
export function policyStudioRoutes(
  mode: PolicyStudioMode,
): DebugPolicyStudioRoutes | ReviewPolicyStudioRoutes
export function policyStudioRoutes(mode: PolicyStudioMode) {
  return mode === 'debug' ? debugPolicyStudioRoutes : reviewPolicyStudioRoutes
}
